<template>
  <div id="screen2" ref="screen1">
    <div class="title">
      <div class="user">
        <span><i class="el-icon-user"></i> {{ userName }}</span>
        <span v-if="isAdmin == 1" @click="returnS1"
          ><i class="el-icon-d-arrow-left">返回</i></span
        >
      </div>
      <div class="ws">
        <!-- <div class="weather">
          <iframe
            width="300"
            height="30"
            src="https://i.tianqi.com/?c=code&a=getcode&id=34&py=chongqing&icon=1"
            frameborder="0"
          ></iframe>
        </div> -->
        <div>{{ time }}</div>
        <!-- <div id="slogan" ref="slogan">
          国家高新技术企业,让医用织物管理更智能;
        </div> -->
        <marquee
          class="marquee"
          behavior="scroll"
          direction="left"
          style="overflow: hidden"
          scrollamount="5"
          onMouseOver="stop()"
          onMouseOut="start()"
        >
          <div class="item">让 医 用 织 物 管 理 更 智 能</div>
        </marquee>
      </div>
      <div>{{$systemTitle}}</div>
    </div>
    <div class="centent">
      <div class="left">
        <div class="left1">
          <div>医院名称</div>
          <!-- <div><img src="../../assets/image/login/logo.png" alt="" /></div> -->
          <div>{{ hospital.RegionName }}</div>
          <!-- <div></div> -->
        </div>
        <div class="left2">
          <div>织物数量</div>
          <div>
            总数计 <span>{{ totalNum }}</span> 件
          </div>
        </div>
        <div class="left3">
          <div>织物使用率</div>
          <div>
            <Eharts :options="options1" ref="charts1"></Eharts>
          </div>
        </div>
        <div class="left4">
          <div>织物收发数据统计</div>
          <div>
            <p></p>
            <p>回收织物</p>
            <p>发放织物</p>
          </div>
          <div>
            <p>TD</p>
            <p>
              <span>{{ sRInfo.td.rece_num }}</span> 件
            </p>
            <p>
              <span>{{ sRInfo.td.send_num }}</span> 件
            </p>
          </div>
          <div>
            <p>MTD</p>
            <p>
              <span>{{ sRInfo.mtd.rece_num }}</span> 件
            </p>
            <p>
              <span>{{ sRInfo.mtd.send_num }}</span> 件
            </p>
          </div>
          <div>
            <p>YTD</p>
            <p>
              <span>{{ sRInfo.ytd.rece_num }}</span> 件
            </p>
            <p>
              <span>{{ sRInfo.ytd.send_num }}</span> 件
            </p>
          </div>
          <div>{{ sRInfo.lastestBusinessTime }}</div>
        </div>
      </div>
      <div class="right">
        <div class="right1">
          <div class="right_l">
            <div>科室日织物使用量</div>
            <!-- -->
            <div id="rankParent2" ref="rankParent2">
              <vue-seamless-scroll
                :data="regionDayInfoList"
                class="seamless-warp"
                :style="{ height: rankData2Height }"
                :class-option="classOption"
              >
                <div id="rankData2" ref="rankData2">
                  <div
                    class="item"
                    v-for="(item, index) in regionDayInfoList"
                    :key="index"
                  >
                    <div class="item1">{{ item.RegionName }}</div>
                    <div class="item2">
                      收脏数量：<span>{{ item.use_num }}</span>
                    </div>
                    <div class="item3">
                      <el-button
                        size="mini"
                        @click.native="regionDayInfoDetail(item)"
                        type="primary"
                        >点击查看详情 > ></el-button
                      >
                    </div>
                  </div>
                </div>
              </vue-seamless-scroll>
            </div>
            <div>净织物未配送实时数据</div>
            <div id="scroll_unrece" ref="scroll_unrece">
              <!-- <left-scroll ref="leftscroll" :data='regionUnReceInfoLsit' /> -->
              <vue-seamless-scroll
                :data="regionUnReceInfoLsit"
                class="seamless-warp-left"
                :class-option="leftOption"
              >
               <ul :style="{ width: scrollUlWidth }">
                  <li v-for="(item, i) in regionUnReceInfoLsit" :key="i">
                    {{ item.content || '无' + i }}
                  </li>
               </ul>
              </vue-seamless-scroll>
            </div>
          </div>
          <div class="right_r">
            <div>
              <div>织物滞留分析</div>
              <div>
                <Eharts :options="options2" ref="charts2"></Eharts>
              </div>
            </div>
            <div>
              <div>织物洗涤次数分析</div>
              <div>
                <Eharts :options="options3" ref="charts3"></Eharts>
              </div>
            </div>
          </div>
        </div>
        <div class="right2">
          <div>织物分布统计</div>
          <div>
            <div>
              <div>
                <Eharts :options="options4" ref="charts4"></Eharts>
              </div>
              <div>
                <span>普通科室</span>
              </div>
            </div>
            <div>
              <div>
                <Eharts :options="options5" ref="charts5"></Eharts>
              </div>
              <div><span>手术室</span></div>
            </div>
            <div>
              <div>
                <Eharts :options="options6" ref="charts6"></Eharts>
              </div>
              <div><span>工服类分布图</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="isShow" :modal="false" width="80%">
      <div class="box">
        <div v-for="(item, index) in regionDayInfoDetailList" :key="index">
          <div>{{ item.ClassName }}</div>
          <div>
            尺寸: <span>{{ item.SizeName }}</span>
          </div>
          <div>
            数量: <span>{{ item.TextileCount }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Eharts from "@/components/echarts";
import vueSeamlessScroll from "vue-seamless-scroll";
import LeftScroll from "@/components/leftscroll";
export default {
  components: {
    Eharts,
    vueSeamlessScroll,
    LeftScroll,
  },

  data() {
    return {
      rankData2Height: "480px",
      scrollUlWidth: "9999px",
      clientHeight: "0",
      userName: localStorage.getItem("userName"),
      isAdmin: localStorage.getItem("isAdmin"),
      time: null,
      date: null,
      hospital: null,
      totalNum: 1,
      options1: {
        legend: {
          icon: "roundRect",
          right: 0,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          itemWidth: 20,
          itemHeight: 5,
        },
        grid: {
          left: 0,
          top: "20%",
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: 16,
            },
          },
          data: [
            "10/18",
            "10/19",
            "10/20",
            "10/21",
            "10/22",
            "10/23",
            "10/24",
            "10/25",
            "10/26",
            "10/27",
            "10/28",
            "10/29",
            "10/30",
            "10/31",
          ],
        },
        yAxis: {
          splitNumber: 3,
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: 16,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#324570",
            },
          },
        },
        color: [
          "rgba(185, 145, 255, 0.5)",
          "rgba(67, 128, 240, 0.5)",
          "rgba(43, 254, 192, 0.5)",
        ],
        series: [
          {
            name: "住院综合楼",
            type: "line",
            smooth: true,
            symbol: "none",
            lineStyle: {
              color: "rgba(185, 145, 255, 0.5)",
              width: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(185, 145, 255, 0.8)",
                  },
                  {
                    offset: 1,
                    color: "rgba(13, 174, 255, 0)",
                  },
                ],
              },
            },
            data: [
              3, 7.3, 6.3, 2.4, 1.6, 3.01, 4.4, 0.3, 1.72, 0.4, 0.2, 3.1, 2.5,
              5.2, 4.7, 5.2, 1.5,
            ],
          },
          {
            name: "门诊楼",
            type: "line",
            smooth: true,
            symbol: "none",
            lineStyle: {
              color: "rgba(67, 128, 240, 0.5)",
              width: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(67, 128, 240, 0.8)",
                  },
                  {
                    offset: 1,
                    color: "rgba(13, 174, 255, 0)",
                  },
                ],
              },
            },
            data: [
              3.19, 6.2, 8.4, 1.3, 0.42, 8.33, 4.29, 3.3, 5, 4.3, 6, 9.2, 5.2,
              4, 3,
            ],
          },
        ],
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#fff",
            fontSize: 18,
          },
        },
      },
      options2: {
        legend: {
          right: 0,
          top: 10,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: ["医院1", "医院2", "医院3", "医院4", "医院5", "医院6", "医院7"],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
        },
        grid: {
          top: "25%",
          bottom: 0,
          left: "3%",
          right: "1%",
          containLabel: true,
        },
        series: [
          {
            type: "bar",
            name: "病房类",
            showSymbol: false,
            // barWidth: 25,
            barGap: "20%",
            barCategoryGap: "50%",
            data: [],
            smooth: true,
            itemStyle: {
              color: "#00d2f6",
            },
          },
          {
            type: "bar",
            name: "工服类",
            showSymbol: false,
            // barWidth: 25,
            data: [],
            smooth: true,
            itemStyle: {
              color: "#006ce6",
            },
          },
          {
            type: "bar",
            name: "手术室",
            showSymbol: false,
            // barWidth: 25,

            data: [],
            smooth: true,
            itemStyle: {
              color: "#4d9f87",
            },
          },
          {
            type: "bar",
            name: "其它类",
            showSymbol: false,
            // barWidth: 25,

            data: [],
            smooth: true,
            itemStyle: {
              color: "#6870d0",
            },
          },
        ],
      },
      options3: {
        legend: {
          // data: [
          //   "工作服",
          //   "病员服",
          //   "手术服",
          //   "刷手服",
          //   "中单",
          //   "床品",
          //   "孔巾"
          // ],
          right: 0,
          top: 0,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            // interval: 0, //强制显示文字
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: [
            "0-20",
            "21-40",
            "41-60",
            "61-80",
            "81-100",
            "101-120",
            "121-140",
            "140以上",
          ],
        },
        color: ["#00d2f6", "#006ce6", "#4d9f87", "#6870d0"],
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
        },
        grid: {
          top: "25%",
          bottom: 0,
          left: "3%",
          right: "1%",
          containLabel: true,
        },
        series: [
          {
            type: "bar",
            name: "病房类",
            stack: "类别",
            data: [],
          },
          {
            type: "bar",
            name: "工服类",
            stack: "类别",
            data: [],
          },
          {
            type: "bar",
            name: "手术室",
            stack: "类别",
            data: [],
          },
          {
            type: "bar",
            name: "其它类",
            stack: "类别",
            data: [],
          },
        ],
      },
      options4: {
        legend: {
          right: 0,
          top: 10,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
        },
        grid: {
          top: "30%",
          bottom: "1%",
          left: "3%",
          right: "1%",
          containLabel: true,
        },
        color: ["#00d2f6", "#006ce6", "#4d9f87", "#6870d0"],
        series: [
          {
            type: "bar",
            name: "病房类",
            showSymbol: false,
            // barWidth: 25,
            barGap: "20%",
            barCategoryGap: "50%",
            data: [105, 229, 391, 434, 457, 376, 391],
            smooth: true,
          },
          {
            type: "bar",
            name: "工服类",
            showSymbol: false,
            // barWidth: 25,
            data: [156, 490, 434, 490, 400, 530, 510],
            smooth: true,
          },
          {
            type: "bar",
            name: "手术室",
            showSymbol: false,
            // barWidth: 25,

            data: [126, 323, 451, 391, 434, 490, 530],
            smooth: true,
          },
          {
            type: "bar",
            name: "其它类",
            showSymbol: false,

            data: [126, 323, 451, 391, 434, 490, 530],
            smooth: true,
          },
        ],
      },
      options5: {
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: ["品名1", "品名2", "品名3", "品名4"],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
          minInterval: 1000,
        },
        grid: {
          top: "30%",
          bottom: "1%",
          left: "3%",
          right: "1%",
          containLabel: true,
        },
        color: ["#00d2f6"],
        series: [
          {
            type: "bar",
            showSymbol: false,
            barWidth: 50,
            barGap: "20%",
            barCategoryGap: "50%",
            data: [],
            smooth: true,
          },
        ],
      },
      options6: {
        legend: {
          right: 0,
          top: 10,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: ["科室1", "科室2", "科室3", "科室4"],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
          minInterval: 1000
        },
        grid: {
          top: "30%",
          bottom: "1%",
          left: "3%",
          right: "1%",
          containLabel: true,
        },
        color: ["#00d2f6", "#006ce6", "#4d9f87", "#6870d0"],
        series: [
          {
            type: "bar",
            name: "病房类",
            showSymbol: false,
            // barWidth: 25,
            barGap: "20%",
            barCategoryGap: "50%",
            data: [105, 229, 391, 434, 457, 376, 391],
            smooth: true,
          },
          {
            type: "bar",
            name: "工服类",
            showSymbol: false,
            // barWidth: 25,
            data: [156, 490, 434, 490, 400, 530, 510],
            smooth: true,
          },
          {
            type: "bar",
            name: "手术室",
            showSymbol: false,
            // barWidth: 25,

            data: [126, 323, 451, 391, 434, 490, 530],
            smooth: true,
          },
          {
            type: "bar",
            name: "其它类",
            showSymbol: false,

            data: [126, 323, 451, 391, 434, 490, 530],
            smooth: true,
          },
        ],
      },
      sRInfo: {
        td: {
          rece_num: undefined,
          send_num: undefined,
        },
        mtd: {
          rece_num: undefined,
          send_num: undefined,
        },
        ytd: {
          rece_num: undefined,
          send_num: undefined,
        },
        lastestBusinessTime: undefined,
      },
      regionUnReceInfoLsit: [],
      regionDayInfoList: [],
      regionDayInfoDetailList: [],
      showRankInterVal2: [],
      isShow: false,
      regionUnReceDetailList: [],
      classOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      },
      leftOption: {
        limitMoveNum: 1,
        step: 2,
        direction: 2,
      },
    };
  },

  created() {
    // // 获取浏览器可视区域高度
    // this.clientHeight = document.documentElement.clientHeight;
    // let that = this;
    // window.onresize = function temp() {
    //   // 在窗口或框架被调整大小时触发
    //   this.clientHeight = document.documentElement.clientHeight;
    //   that.$router.go(0);
    // };
    this.hospital = {
      ID: this.$route.query.hospitalID,
      RegionName: this.$route.query.RegionName,
    };
  },
  mounted() {
    var timeTimer = setInterval(() => {
      this.setTime();
    }, 1000);

    this.textileCount();
    this.textileUseRate();
    this.sendAndReceInfo();
    this.regionDayInfo();
    this.regionUnReceInfo();
    this.regionUnsendInfo();
    this.textileWashTimesInfo();
    this.textileRegionStoreInfo();
    this.textileOperationStoreInfo();
    this.employeeTextileStoreInfo();

    var reloadTimer = setInterval(() => {
      this.sendAndReceInfo();
    }, 5000);
  },
  methods: {
    setTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      let week = date.getDay();
      switch (week) {
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
        case 0:
          week = "星期日";
          break;
        default:
          break;
      }
      var mytime = date.toLocaleTimeString(); //获取当前时间
      this.date = year + "-" + month + "-" + day;
      this.time = year + "-" + month + "-" + day + " " + week + " " + mytime;
    },

    changeFixed(clientHeight) {
      // 动态修改样式
      this.$refs.screen1.style.height = clientHeight + "px";
    },
    // 各医院每日收发布草情况
    textileCount() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/textileCount?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.totalNum = resData.num;
      });
    },
    // 医院布草使用率
    textileUseRate() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/textileUseRate?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [];
        resData.forEach((item) => {
          arr1.push(item.day);
          switch (item.RegionName) {
            case "住院综合楼":
              arr2.push(item.use_rate);
              break;
            case "门诊楼":
              arr3.push(item.use_rate);
              break;
            default:
              break;
          }
        });
        arr1 = Array.from(new Set(arr1));
        this.options1.xAxis.data = arr1.reverse();
        this.options1.series[0].data = arr2.reverse();
        this.options1.series[1].data = arr3.reverse();
        this.$refs.charts1.drawCharts();
      });
    },
    // 织物收发数据统计
    sendAndReceInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/sendAndReceInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let reloadFlag = false;

        let resData = res.data;

        if (
          this.sRInfo.lastestBusinessTime &&
          this.sRInfo.lastestBusinessTime != resData.lastestBusinessTime
        ) {
          reloadFlag = true;
        }

        this.sRInfo = resData;

        console.log("reloadFlag :" + reloadFlag + " time : " + this.time);

        if (reloadFlag) {
          this.textileCount();
          this.textileUseRate();
          this.regionDayInfo();
          this.regionUnReceInfo();
          this.regionUnsendInfo();
          this.textileWashTimesInfo();
          this.textileRegionStoreInfo();
          this.textileOperationStoreInfo();
          this.employeeTextileStoreInfo();
        }
      });
    },
    //科室当日使用情况
    regionDayInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/regionDayInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.regionDayInfoList = resData;
        var rows = Math.floor((this.regionDayInfoList.length - 1) / 4) + 1;
        // console.log(rows);
        if (rows <= 3) {
          this.rankData2Height = rows * 6 + "rem";
        }

        this.$nextTick(() => {
          //var ulbox = this.$refs.rankParent2;
          //var ul1 = this.$refs.rankData2;
          // this.roll(
          //   60,
          //   this.showRankInterVal2,
          //   this.$refs.rankParent2,
          //   this.$refs.rankData2
          // );
        });
      });
    },
    //科室未收情况统计
    regionUnReceInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/regionUnReceInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.regionUnReceInfoLsit = resData;

        this.scrollUlWidth = 500 * this.regionUnReceInfoLsit.length + 'px';

        this.regionUnReceInfoLsit.forEach((item, i) => {
          let content = '';
          content += (i + 1) + ". " + item.RegionName + "    ";
          content += item.TaskTime + "    ";
          content += item.ClassName + "    ";
          content += "未配送数量" + item.unrece_num + "件";
          item.content = content;
        })


        this.$nextTick(() => {
          // this.$refs.leftscroll._initMenu();
          // this.roll(
          //   60,
          //   this.showRankInterVal2,
          //   this.$refs.scroll_unrece,
          //   this.$refs.scroll_unrece_content
          // );
        });
      });
    },

    // 各科室、类型布草滞留分析
    regionUnsendInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/regionUnsendInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [],
          arr4 = [],
          arr5 = [];
        resData.forEach((item) => {
          arr1.push(item.RegionName);
          arr2.push(item.y_病房类);
          arr3.push(item.y_工服类);
          arr4.push(item.y_手术室);
          arr5.push(item.y_其他类);
        });
        this.options2.xAxis.data = arr1;
        this.options2.series[0].data = arr2;
        this.options2.series[1].data = arr3;
        this.options2.series[2].data = arr4;
        this.options2.series[3].data = arr5;
        this.$refs.charts2.drawCharts();
      });
    },
    // 布草洗涤次数统计
    textileWashTimesInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/textileWashTimesInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [],
          arr4 = [];
        resData.forEach((item) => {
          switch (item.CateName) {
            case "病房类":
              delete item.CateName;
              delete item.ID;
              arr1.push(
                item["0-20"],
                item["21-40"],
                item["41-60"],
                item["61-80"],
                item["81-100"],
                item["101-120"],
                item["121-140"],
                item["140以上"]
              );
              break;
            case "工服类":
              delete item.CateName;
              delete item.ID;
              arr2.push(
                item["0-20"],
                item["21-40"],
                item["41-60"],
                item["61-80"],
                item["81-100"],
                item["101-120"],
                item["121-140"],
                item["140以上"]
              );
              break;
            case "手术室":
              delete item.CateName;
              delete item.ID;
              arr3.push(
                item["0-20"],
                item["21-40"],
                item["41-60"],
                item["61-80"],
                item["81-100"],
                item["101-120"],
                item["121-140"],
                item["140以上"]
              );
              break;
            case "其它类":
              delete item.CateName;
              delete item.ID;
              arr4.push(
                item["0-20"],
                item["21-40"],
                item["41-60"],
                item["61-80"],
                item["81-100"],
                item["101-120"],
                item["121-140"],
                item["140以上"]
              );
              break;

            default:
              break;
          }
        });
        this.options3.series[0].data = arr1;
        this.options3.series[1].data = arr2;
        this.options3.series[2].data = arr3;
        this.options3.series[3].data = arr4;
        this.$refs.charts3.drawCharts();
      });
    },
    // 科室布草分布
    textileRegionStoreInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/textileRegionStoreInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [],
          arr4 = [],
          arr5 = [];
        resData.forEach((item) => {
          arr1.push(item.RegionName);
          switch (item.CateName) {
            case "病房类":
              arr2.push(item.store_num);
              break;
            case "工服类":
              arr3.push(item.store_num);
              break;
            case "手术室":
              arr4.push(item.store_num);
              break;
            case "其它类":
              arr5.push(item.store_num);
              break;

            default:
              break;
          }
        });
        arr1 = Array.from(new Set(arr1));
        this.options4.xAxis.data = arr1;
        this.options4.series[0].data = arr2;
        this.options4.series[1].data = arr3;
        this.options4.series[2].data = arr4;
        this.options4.series[3].data = arr5;
        this.$refs.charts4.drawCharts();
      });
    },
    // 手术室布草分布
    textileOperationStoreInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/textileOperationStoreInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [];
        resData.forEach((item) => {
          arr1.push(item.CateName);
          arr2.push(item.store_num);
        });
        this.options5.xAxis.data = arr1;
        this.options5.series[0].data = arr2;
        this.$refs.charts5.drawCharts();
      });
    },
    // 工服布草分布
    employeeTextileStoreInfo() {
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/employeeTextileStoreInfo?hospitalId=" +
          this.hospital.ID,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [],
          arr4 = [],
          arr5 = [];
        resData.forEach((item) => {
          arr1.push(item.RegionName);
          switch (item.CateName) {
            case "病房类":
              arr2.push(item.store_num);
              break;
            case "工服类":
              arr3.push(item.store_num);
              break;
            case "手术室":
              arr4.push(item.store_num);
              break;
            case "其它类":
              arr5.push(item.store_num);
              break;

            default:
              break;
          }
        });
        arr1 = Array.from(new Set(arr1));
        this.options6.xAxis.data = arr1;
        this.options6.series[0].data = arr2;
        this.options6.series[1].data = arr3;
        this.options6.series[2].data = arr4;
        this.options6.series[3].data = arr5;
        this.$refs.charts6.drawCharts();
      });
    },
    // 滚动效果
    /**
     *
     * @param {*速度} t
     * @param {*window对象用于清除定时器} container
     * @param {* 父容器id} ulbox
     * @param {* 子容器id} ul1
     */
    roll(t, container, ulbox, ul1) {
      let that = this;
      if (this.$refs.rankParent2) {
        //var ulbox = this.$refs.rankParent2;
        //var ul1 = this.$refs.rankData2;
        ul1.scrollTop = 0; // 开始无滚动时设为0
        var timer2 = setInterval(() => {
          // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
          if (ul1.scrollTop + ul1.clientHeight > ul1.scrollHeight) {
            ul1.scrollTop = 0;
          } else {
            ul1.scrollTop += 1;
          }
        }, t);

        // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
        // 鼠标移入div时暂停滚动
        container.push(timer2);
        ulbox.onmouseover = function () {
          clearInterval(timer2);
          // container.forEach(function(item) {
          //   clearInterval(item);
          // });
        };
        // 鼠标移出div后继续滚动
        ulbox.onmouseout = function () {
          timer2 = setInterval(() => {
            // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
            if (ul1.scrollTop + ul1.clientHeight >= ul1.scrollHeight) {
              ul1.scrollTop = 0;
            } else {
              ul1.scrollTop += 1;
            }
          }, t);
          container.push(timer2);
        };
      }
    },
    // 单个科室日收脏情况详情
    regionDayInfoDetail(data) {
      // console.log(data);
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/regionDayInfoDetail?hospitalId=" +
          this.hospital.ID +
          "&regionId=" +
          data.RegionID +
          "&day=" +
          data.day,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.isShow = true;
        this.regionDayInfoDetailList = resData;
      });
    },
    // 单个科室未收情况明细
    regionUnReceDetail(data) {
      // console.log(data);
      const requestData = {
        url:
          process.env.BASE_API +
          "/hospital/regionUnReceDetail?hospitalId=" +
          this.hospital.ID +
          "&regionId=" +
          data.send_region,
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.isShow = true;
        this.regionUnReceDetailList = resData;
      });
    },
    handleClose() {
      this.isShow = false;
    },
    returnS1() {
      this.$router.push("/screen1");
    },
  },
  watch: {
    // // 监听屏幕高度
    // clientHeight() {
    //   this.changeFixed(this.clientHeight);
    // }
  },
  beforeDestroy() {
    this.showRankInterVal2.forEach((item) => {
      clearInterval(item);
    });
  },
};
</script>

<style lang="less" scoped>
#screen2 {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../../assets/image/screen1/bg_1_v2.jpeg") no-repeat;
  background-size: 100% 100%;

  .title {
    height: 6.5%;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    color: #00cdff;
    font-size: 1.2rem;

    div:nth-child(3) {
      flex: 10;
      text-align: right;
      padding-right: 19rem;
      font-size: 2rem;
      font-weight: bold;
    }

    .ws {
      flex: 3;
      color: #fff;
      margin-left: 20px;
      .marquee {
        margin-left: 2rem;
        .item {
          margin-top: 5px;
        }
      }

      > div:nth-child(1) {
        padding-left: 2rem;
      }
    }

    #slogan {
      letter-spacing: 1rem;
      height: 50%;
    }

    > .user {
      span:nth-child(1) {
        padding-right: 1.5rem;

        i {
          font-size: 1.5rem;
        }
      }

      span:nth-child(2) {
        position: absolute;
        right: 1.5rem;
        top: 3rem;
        font-size: 1.4rem;
      }
    }
  }

  .centent {
    display: flex;
    width: 100%;
    height: 93.5%;
    padding: 1rem;

    .left {
      flex: 1;
      display: flex;
      flex-direction: column;

      > div {
        margin: 1rem;
        padding: 1rem;
      }

      .left1 {
        flex: 1;
        background: url("../../assets/image/screen2/s2_left1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;

        > div:nth-child(1) {
          font-size: 1.2rem;
          padding: 0.2rem 0 0 1.5rem;
          color: #00cdff;
        }

        // > div:nth-child(2) {
        //   text-align: center;

        //   img {
        //     width: 5rem;
        //     height: 3rem;
        //   }
        // }

        > div:nth-child(2) {
          margin-top: 1.5rem;
          font-size: 1.2rem;
          text-align: center;
          color: #00cdff;
        }
        > div:nth-child(3) {
          position: absolute;
          right: 0;
          top: 0;
          width: 35%;
          height: 55%;
          background: url("../../assets/image/login/logo.png") no-repeat;
          background-size: 100% 100%;
        }
      }

      .left2 {
        flex: 1;
        background: url("../../assets/image/screen2/s2_left2.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          padding: 0.4rem 0 0 1.5rem;
          color: #00cdff;
        }

        > div:nth-child(2) {
          margin-top: 1rem;
          text-align: center;
          color: #ccc;
          font-size: 1.2rem;

          span {
            font-size: 3rem;
            color: #00cdff;
          }
        }
      }

      .left3 {
        flex: 2;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: url("../../assets/image/screen2/s2_left3.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          padding: 0.2rem 0 0 1.5rem;
          color: #00cdff;
        }

        > div:nth-child(2) {
          flex: 1;
          padding: 1rem;
        }
      }

      .left4 {
        flex: 1.5;
        background: url("../../assets/image/screen2/s2_left4.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          padding: 0.5rem 0 0 1.5rem;
          color: #00cdff;
        }

        > div:nth-child(2),
        > div:nth-child(3),
        > div:nth-child(4),
        > div:nth-child(5) {
          display: flex;

          p {
            flex: 1;
            color: #ccc;
            text-align: center;
            margin-top: 0.5rem;

            span {
              font-size: 1.4rem;
              color: #00cdff;
            }
          }

          p:nth-child(1) {
            flex: 0.5;
          }
        }

        > div:nth-child(6) {
          color: #00cdff;
          margin: 0.5rem 3rem 0 0;
          text-align: right;
        }
      }
    }

    .right {
      flex: 2.5;
      display: flex;
      flex-direction: column;

      > div {
        margin: 1rem;
        padding: 1rem;
      }

      .right1 {
        flex: 2;
        display: flex;

        .right_l {
          flex: 1.3;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;

          > div:nth-child(1) {
            margin-top: 1.5rem;
            font-size: 1.2rem;
            color: #00cdff;
            padding: 0.5rem 0 0.5rem 1rem;
            background: url("../../assets/image/screen2/s2_right1_t.png")
              no-repeat;
            background-size: 40% 100%;
          }

          #rankParent2 {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 85%;
            overflow: hidden;
            #rankData2 {
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              overflow-y: auto;
              padding-right: 1rem;
              align-content: flex-start;
              .item {
                // flex: 20%;
                width: 22.5%;
                // height: 20%;
                margin: 0.5rem;
                margin-bottom: 0;
                text-align: center;
                background: url("../../assets/image/screen2/s2_right1.png")
                  no-repeat;
                background-size: 100% 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;

                .item1 {
                  color: #fff;
                  font-size: 1rem;
                }

                .item2 {
                  color: #ccc;
                  font-size: 0.8rem;
                }

                .item3 {
                  /deep/ .el-button {
                    width: 70%;
                    font-size: 0.5rem;
                    background: linear-gradient(to right, #0066e5, #00b6ff);
                    border: 0;
                  }
                }
              }
            }
          }

          > div:nth-child(3) {
            font-size: 1.2rem;
            color: #00cdff;
            padding: 0.5rem 0 0.5rem 1rem;
            background: url("../../assets/image/screen2/s2_right1_t.png")
              no-repeat;
            background-size: 40% 100%;
            height: 7%;
          }

          #scroll_unrece {
            //position: absolute;
            left: 0;
            height: 3rem;
            width: 96%;
            background: url("../../assets/image/screen2/s2_right1.png")
              no-repeat;
            background-size: 100% 100%;
          }
        }

        .right_r {
          flex: 1;
          display: flex;
          flex-direction: column;

          > div {
            flex: 1;
            padding: 1rem;
            background: url("../../assets/image/screen2/s2_right2.png")
              no-repeat;
            background-size: 100% 100%;
          }

          > div:nth-child(1) {
            margin-bottom: 1rem;
            display: flex;
            flex-direction: column;
            background: url("../../assets/image/screen2/s2_right2.png")
              no-repeat;
            background-size: 100% 100%;

            > div:nth-child(1) {
              font-size: 1.2rem;
              color: #00cdff;
              padding: 0.4rem 0 0 1rem;
            }

            > div:nth-child(2) {
              flex: 1;
              padding: 1rem 0 0 0;
            }
          }

          > div:nth-child(2) {
            display: flex;
            flex-direction: column;
            background: url("../../assets/image/screen2/s2_right3.png")
              no-repeat;
            background-size: 100% 100%;

            > div:nth-child(1) {
              font-size: 1.3rem;
              color: #00cdff;
              padding: 0.4rem 0 0 1rem;
            }

            > div:nth-child(2) {
              padding: 1rem 0 0 0;
              flex: 1;
            }
          }
        }
      }

      .right2 {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: url("../../assets/image/screen2/s2_right4.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          padding: 0 0 0 1rem;
          color: #00cdff;
        }

        > div:nth-child(2) {
          flex: 1;
          display: flex;
          padding: 0 2rem;

          > div {
            flex: 1;
            display: flex;
            flex-direction: column;

            > div:nth-child(1) {
              flex: 2;
            }

            > div:nth-child(2) {
              flex: 0.5;
              text-align: center;
              margin-top: 0.5rem;
              span {
                display: inline-block;
                color: #00cdff;
                font-size: 0.4rem;
                padding: 0.3rem 1rem;
                background: url("../../assets/image/screen2/s2_right4_b.png")
                  no-repeat;
                background-size: 100% 100%;
              }
            }
          }

          > div:nth-child(2) {
            margin: 0 5rem;
          }
        }
      }
    }
  }
  /deep/ .el-dialog {
    background-color: RGBA(19, 28, 56, 1);
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    > div {
      margin: 1rem;
      padding: 0.5rem 1.5rem;
      color: #ccc;
      background: url("../../assets/image/screen2/s2_right1.png") no-repeat;
      background-size: 100% 100%;
      span {
        color: #00cdff;
        font-size: 1.2rem;
      }
      > div:nth-child(2) {
        margin: 0.3rem 0;
      }
    }
  }
  .s2_logo {
    position: absolute;
    right: 130px;
    top: 5px;
    width: 11%;
    height: 6%;
    background: url("../../assets/image/screen1/s1_logo.png") no-repeat;
    background-size: 100% 100%;
  }

  .seamless-warp {
    height: 30rem;
  }

  .seamless-warp-left {
    width: 695px;
    position: absolute;
    height: 100%;
    overflow: hidden;

    ul {
      li {
        float: left;
        color: #fff;
        width: 500px;
        margin-right: 10px;
        line-height: 3rem;
        font-size: 1.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/page/screen2.vue